<template>
  <div>
    <div v-if="loading" class="flex content-center justify-center item-center">
      <MoonLoader class="mt-24"> </MoonLoader>
    </div>
    <div v-else>
      <BackButton class="u-margin-bottom-small" />
      <CompaniesIndex :companies="companies"> </CompaniesIndex>
      <CompaniesStatistics :companies_statistics="companies_statistics" :loading="loading"></CompaniesStatistics>
      <CertificationParameters :certification_variables="certification_variables"></CertificationParameters>
    </div>
  </div>
</template>

<script>
import CompaniesIndex from '../Companies/CompaniesIndex';
import axiosAuth from '../../../axiosMain';
import BackButton from '../../../components/buttons/BackButton';
import MoonLoader from '../../../components/svg/SvgLoaderMoon';
import CompanyController from '../../../controllers/Company/CompanyController';
import CertificationParameters from '@/components/Certification/CertificationParameters';
import CompanyCertificationVariablesController from '@/controllers/Certificates/CompanyCertificationVariablesController';
import CompaniesStatistics from '@/components/Statistics/CompaniesStatistics';
import StatisticsController from '@/controllers/Statistics/StatisticsController';
export default {
  name: 'SuperUserIndex',
  components: { CompaniesStatistics, CertificationParameters, MoonLoader, BackButton, CompaniesIndex },
  data: function () {
    return {
      companies: {},
      loading: null,
      certification_variables: null,
      companies_statistics: {},
    };
  },
  mounted() {
    this.loadCompanies();
    this.certificationVariables();
    this.getCompaniesStatistics();
  },
  methods: {
    setLoader: function () {
      this.loading = true;
    },
    resetLoader: function () {
      this.loading = false;
    },
    async loadCompanies() {
      this.setLoader();
      this.companies = await CompanyController.index();
      this.resetLoader();
    },
    async certificationVariables() {
      this.setLoader();
      this.certification_variables = await CompanyCertificationVariablesController.index();
      this.resetLoader();
    },
    async getCompaniesStatistics() {
      this.setLoader();
      this.companies_statistics = await StatisticsController.index();
      this.resetLoader();
    },
  },
};
</script>

<style scoped></style>
